import moment from 'moment';
import React from 'react';

import { SignedConsentMeta } from '../SignedConsent.styled';
import { SignedConsentTitle, SignedConsentHeaderContainer } from './SignedConsentHeader.styled';
import { NullableString, Patient } from 'kb-shared';

import { SignedConsentHeaderProps } from './SignedConsentHeader.types';

export const SignedConsentHeader: React.FC<SignedConsentHeaderProps> = ({
  completedAt,
  patient,
  patientNameFromConsent
}) => {
  const isValidBirthday = () => {
    return moment.tz(patient.birthday, 'UTC').isValid();
  };

  return (
    <SignedConsentHeaderContainer>
      <SignedConsentTitle>Copy of Patient Consent</SignedConsentTitle>
      <SignedConsentMeta>
        {'Patient: '}
        {getPatientName(patient, patientNameFromConsent)}
      </SignedConsentMeta>
      {patient.birthday && (
        <SignedConsentMeta>
          {'DOB: '}
          {isValidBirthday() ? moment.tz(patient.birthday, 'UTC').format('MM/DD/YYYY') : '-'}
        </SignedConsentMeta>
      )}
      {patient.id && (
        <SignedConsentMeta>
          {'MRN: '}
          {patient.id}
        </SignedConsentMeta>
      )}
      <SignedConsentMeta>
        {'Electronically Signed On: '}
        {completedAt}
      </SignedConsentMeta>
      <SignedConsentMeta>
        {'Electronically Signed By: '}
        {getPatientName(patient, patientNameFromConsent)}
      </SignedConsentMeta>
    </SignedConsentHeaderContainer>
  );
};

export const getPatientName = (patient: Patient, patientNameFromConsent: NullableString) => {
  if (patientNameFromConsent) return patientNameFromConsent;
  return currentPatientName(patient);
};

const currentPatientName = (patient: Patient) => `${patient.firstName} ${patient.lastName}`;
